module.exports = __webpack_public_path__ + "img/bread-slice.d197f9d0.png";